import {
  Routes as ReactRouterRoutes,
  Route as ReactRouterRoute,
} from "react-router-dom";

import { GuestUserRoute } from "./shared/components/guest-user-route";
import { LoggedUserRoute } from "./shared/components/logged-user-route";
import Home from "./pages/home/home";
import Login from "./pages/login/login";
import Event from "./pages/event/event.tsx";
import Policies from "./pages/policies/policies.tsx";
import Profile from "./pages/profile/profile.tsx";
import Checkout from "./pages/checkout/checkout.tsx";
import Contact from "./pages/contact/contact.tsx";
import Commercial from "./pages/commercial/commercial.tsx";
import NotFound from "./pages/not-found/not-found.tsx";
import GoogleCallback from "./pages/auth/google-callback.tsx";
import FacebookCallback from "./pages/auth/facebook-callback.tsx";

const Routes = () => {
  return (
    <ReactRouterRoutes>
      {/* Public routes - accessible by everyone */}
      <ReactRouterRoute index element={<Home/>} />
      <ReactRouterRoute path="/evento/:id" element={<Event/>} />
      <ReactRouterRoute path="/politicas/:slug" element={<Policies/>} />
      <ReactRouterRoute path="/finalizar-compra/:step" element={<Checkout/>} />
      <ReactRouterRoute path="/contato" element={<Contact/>} />
      <ReactRouterRoute path="/comercial/*" element={<Commercial/>} />

      {/* OAuth callback routes - public but require query params from OAuth provider */}
      <ReactRouterRoute path="/auth/google/callback" element={<GoogleCallback />} />
      <ReactRouterRoute path="/auth/facebook/callback" element={<FacebookCallback />} />

      {/* Guest only routes - redirect to home if logged in */}
      <ReactRouterRoute element={<GuestUserRoute />}>
        <ReactRouterRoute path="/entrar" element={<Login/>} />
      </ReactRouterRoute>
      
      {/* Protected routes - require authentication */}
      <ReactRouterRoute element={<LoggedUserRoute />}>
        <ReactRouterRoute path="/perfil/*" element={<Profile/>} />
      </ReactRouterRoute>

      {/* Catch all - 404 Not Found */}
      <ReactRouterRoute path="*" element={<NotFound/>} />
    </ReactRouterRoutes>
  );
};

export default Routes;
